import text from './text'
import $ from 'jquery'
import _ from 'lodash'
import yp from './yp'
import 'bootstrap'
import ckeditor from './editor'
import notify from './notify'

var defaults = {
  all: undefined,
  ctx: '',
  lang: 'en',
  langs: ['en', 'es'],
  elem: undefined,
  plaintext: undefined,
  useInput: false,
  google_token: undefined,
  form: undefined,
  tacks: undefined,
  height: 200,
  check_empty: false,
  initFinCallback: undefined,
  id: undefined,
}

var initAsync = function (D) {
  D.google_token = D.elem.find('input[name="google-translate-token"]').val()
  if (D.google_token) {
    D.elem.find('.auto-translate').click(function () {
      autoTranslate(D, this)
    })
  }

  D.tacks = {}
  _(D.langs).each(function (l) {
    var ta = textarea(D, l)
    if (!D.plaintext && ta.data('ckeditor') === null) {
      console.error('MultiLanguageEditor::could not find ckeditor textarea')
      return
    }

    var tack = D.plaintext ? ta : ta.data('ckeditor')
    D.tacks[l] = tack
    tack.on(D.plaintext ? 'change' : 'blur', function () {
      onOff(D, l)
    })
  })
  onOffAll(D)

  D.onOffAll = function () {
    onOffAll(D)
  }
  if (D.initFinCallback !== undefined) {
    D.initFinCallback(D)
  }
}

var autoTranslate = function (D, button) {
  notify.clear()
  $button = $(button)
  $button.prop('disabled', 'disabled')

  var srcL = undefined
  var pending = 0
  _(D.langs).each(function (l) {
    onOff(D, l)
    var content = getTackContent(D, D.tacks[l])
    var empty = _.isEmpty(content)
    if (srcL === undefined && !empty) {
      srcL = l
    } else if (empty) {
      pending += 1
    }
  })

  if (srcL === undefined) {
    console.log('MultiLanguageEditor::No text given for any language')
    $button.blur()
    $button.prop('disabled', false)
    return
  }

  var sourceT = getTackContent(D, D.tacks[srcL])
  _(D.all).each(function (content, l) {
    if (l != srcL && _.isEmpty(content)) {
      console.log('Fetching translation for: ' + l)
      $.ajax({
        url: 'https://www.googleapis.com/language/translate/v2',
        format: D.plaintext ? 'text' : 'html',
        dataType: 'json',
        headers: { 'X-HTTP-Method-Override': 'GET' },
        data: {
          target: l,
          source: srcL,
          format: D.plaintext ? 'text' : 'html',
          key: D.google_token,
          q: sourceT,
        },
        success: function (response) {
          console.log('Received translation for ' + l)
          setTackContent(D, D.tacks[l], response.data.translations[0].translatedText)
          onOff(D, l)
          pending -= 1
          if (pending == 0) {
            notify.message(text('misc.translate.success'))
            $button.blur()
            $button.prop('disabled', false)
          }
        },
        error: function () {
          yp.showAjaxError()
          pending -= 1
          if (pending == 0) {
            notify.error(text('misc.translate.failure'))
            $button.blur()
            $button.prop('disabled', false)
          }
        },
      })
    }
  })
  if (pending == 0) {
    $button.blur()
    $button.prop('disabled', false)
  }
}

var id = function (D, lang) {
  return '#' + D.id + '-' + lang
}

var getTackContent = function (D, tack) {
  return D.plaintext ? $(tack).val() : tack.getData()
}

var setTackContent = function (D, tack, data) {
  if (D.plaintext) {
    var $tack = $(tack)
    $tack.val(data)
    $tack.trigger('change')
  } else {
    tack.setData(data)
    tack.fire('blur')
  }
}

var tabId = function (D, lang) {
  return id(D, lang) + '-tab'
}

var tab = function (D, lang) {
  var tab = $(tabId(D, lang), D.elem)

  if (tab.length === 0) {
    console.error('MultiLanguageEditor::could not find a tab for lang: ' + lang)
  }
  return tab
}

var textarea = function (D, lang) {
  var ta = D.useInput ? $('input', id(D, lang)) : $('textarea', id(D, lang))

  if (ta.length === 0) {
    console.error('MultiLanguageEditor::could not find textarea for lang: ' + lang)
  }
  return ta
}

var markError = function (D, l, f) {
  mark(D, l, 'glyphicon-remove', f)
}

var markOk = function (D, l, f) {
  mark(D, l, 'glyphicon-ok', f)
}

var mark = function (D, l, glyphicon, f) {
  var a = $('a', tabId(D, l))

  a.text(a.text().replace(/ *$/, ''))
  $('span', a).remove()
  a.append(' ')
  $('<span/>')
    .addClass('glyphicon')
    .addClass(glyphicon)
    .appendTo(a)
  if (f !== undefined) {
    f(a)
  }
}

var onOffAll = function (D) {
  _(D.langs).each(function (l) {
    onOff(D, l)
  })
}

var onOff = function (D, l) {
  var tack = D.tacks[l]
  D.all[l] = getTackContent(D, tack)
  if (_(D.all).values().join('').length > 0) {
    D.form.val(JSON.stringify(D.all))
  } else {
    D.form.val(JSON.stringify(''))
  }

  if (D.check_empty) {
    var content = getTackContent(D, tack)
    if (content !== '') {
      var a = $('a', tabId(D, l))
      a.text(a.text().replace(/ *$/, ''))
      $('span', a).remove()
      a.text(a.text() + ' ')
      $('<span/>').addClass('glyphicon').addClass('glyphicon-ok').appendTo(a)
    } else {
      var b = $('a', tabId(D, l))
      b.text(b.text().replace(/ *$/, ''))
      $('span', b).remove()
    }
  }
}

export default {
  init: function (opts) {
    var D = $.extend({}, defaults, opts || {})
    var functions = {
      markError: function (l, f) { return markError(D, l, f) },
      markOk: function (l, f) { return markOk(D, l, f) },
      mark: function (l, glyphicon, f) { return mark(D, l, glyphicon, f) },
      getTextarea: function (l) { return textarea(D, l) },
    }
    D = $.extend(D, functions)

    console.log('MultiLanguageEditor::init', D)
    if (D.elem === undefined || D.elem === '') {
      console.error('MultiLanguageEditor::elem cannot be undefined', D)
      return
    }
    if (typeof D.elem === 'string') {
      D.elem = $(D.elem)
    }
    if (D.elem.length === 0) {
      console.error('MultiLanguageEditor::elem does not exist', D)
      return
    }
    D.elem.data('y', D)
    D.plaintext = !D.elem.hasClass('fullta')
    D.useInput = D.elem.hasClass('input')
    D.form = $('.form', D.elem)
    try {
      D.all = JSON.parse(D.form.val())
    } catch (err) {
      D.all = {}
    }

    var nid = D.elem.data('id')

    if (nid !== undefined && nid !== '' && (D.id === undefined || D.id == '')) {
      D.id = nid
    }
    var langs = D.elem.data('langs')

    if (langs !== undefined && langs != '') {
      D.langs = langs.replace('[', '').replace(']', '').replace(/,/g, ' ').split(/ +/);
    }

    console.log('MultiLanguageEditor::init', D)

    _(D.all).each(function (content, l) {
      if (!_(D.langs).includes(l)) {
        delete D.all[l]
        console.group('language: ' + l + ' is not configured for this multieditor')
        console.error('content: "' + content + '"')
        console.groupEnd()
        return
      }
      if (D.useInput) {
        textarea(D, l).val(content)
      } else {
        textarea(D, l).text(content)
      }
    })

    var tas = $(D.useInput ? 'input.multitext' : 'textarea.multitextarea', D.elem)

    if (tas.length == 0) {
      console.error('MultiLanguageEditor::could not find textareas with multitextarea class')
      return
    }

    if (D.plaintext) {
      initAsync(D)
    } else {
      tas.each(function (i, ta) {
        var $ta = $(ta)
        if (!$ta.is(':hidden')) {
          D.height = $ta.height()
          return false
        }
      })
      var count = tas.length
      tas.each(function () {
        var editor = ckeditor.init(this, D.ctx, D.lang,
         {
          height: D.height,

          // Duplicate double quotes in tags so that wordcount accounts for json escaping
          wordcount: {
            filter: new CKEDITOR.htmlParser.filter({
              elements: {
                img: function (element) {
                  element.attributes.alt = ' ' + element.attributes.alt + ' '
                  element.attributes.altid = ' ' + element.attributes.altid + ' '
                  element.attributes.src = ' ' + element.attributes.src + ' '
                },
                a: function (element) {
                  element.attributes.href = ' ' + element.attributes.href + ' '
                  element.attributes.target = ' ' + element.attributes.target + ' '
                  element.attributes.rel = ' ' + element.attributes.rel + ' '
                },
                div: function (element) {
                  element.attributes.style = ' ' + element.attributes.style + ' '
                },
                span: function (element) {
                  element.attributes.style = ' ' + element.attributes.style + ' '
                },
                th: function (element) {
                  element.attributes.scope = ' ' + element.attributes.scope + ' '
                },
              },
            }),
          },
        }, function () {
          count -= 1
          if (count == 0) {
            initAsync(D)
          }
        })
        if (editor === null) {
          console.log('MultiLanguageEditor::CKEDITOR not supported reverting to textareas')
          D.plaintext = true
          return false
        }
      })
      if (D.plaintext) {
        initAsync(D)
      }
    }
  },
}
